import { createSelector } from '@ngrx/store';
import { FeatureFlags } from 'src/app/featureFlags';
import { IImmutableState } from 'src/shared/types/immutable-state';
import { AppState } from '../app-state';

export type ImmutableFeatureFlag = IImmutableState<FeatureFlags>;

export const selectFeatureFlagsFeature = (state: AppState) =>
  state.featureFlags as any as ImmutableFeatureFlag;

export const selectFeatureFlags = createSelector(
  selectFeatureFlagsFeature,
  (state) => (state ? state.toJS() : ({} as FeatureFlags)),
);

export const selectFeatureFlag = <T extends keyof FeatureFlags>(flagName: T) =>
  createSelector(selectFeatureFlags, (state) =>
    state.hasOwnProperty(flagName)
      ? ((state as FeatureFlags)[flagName] as FeatureFlags[T])
      : undefined,
  );
